import { useState, useEffect } from 'react';

interface ResponsiveConfig {
	questionsPerPage: number;
	isMobile: boolean;
}

export function useResponsive(): ResponsiveConfig {
	const getWindowWidth = () => window.innerWidth;
	const [windowWidth, setWindowWidth] = useState(getWindowWidth());
	const isMobile = windowWidth <= 768;
	const questionsPerPage = isMobile ? 1 : 12;

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(getWindowWidth());
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return {
		isMobile,
		questionsPerPage
	};
}
